/**
 * Konfigurator-Link Locale Rewriter
 * Rewrites all links to konfigurator.kiyo.eu based on current locale:
 *   - Swiss market (de-CH)  → konfigurator.kiyo.eu/ch
 *   - English language       → konfigurator.kiyo.eu/en
 *   - Default (de-DE)        → konfigurator.kiyo.eu (unchanged)
 */
(function () {
  'use strict';

  function getLocaleSuffix() {
    var path = window.location.pathname;
    // Swiss market: URL contains /de-ch/ or starts with /de-ch
    if (/\/de-ch(\/|$)/i.test(path)) return '/ch';
    // English: check Shopify locale or URL path
    var lang = window.Shopify && window.Shopify.locale;
    if (lang === 'en' || /\/en(\/|$)/i.test(path)) return '/en';
    // Default: German/DE — no suffix
    return '';
  }

  function rewriteLink(link) {
    try {
      var url = new URL(link.href);
      if (url.hostname === 'konfigurator.kiyo.eu') {
        var suffix = getLocaleSuffix();
        // Strip any existing locale path (/ch, /en) and query params like ?region=ch
        var cleanPath = url.pathname.replace(/^\/(ch|en)(\/|$)/, '/');
        if (cleanPath === '' || cleanPath === '/') cleanPath = '/';
        url.pathname = suffix + cleanPath;
        url.searchParams.delete('region');
        link.href = url.toString();
      }
    } catch (e) {
      // Skip malformed URLs
    }
  }

  function rewriteAllLinks(root) {
    var links = (root || document).querySelectorAll('a[href*="konfigurator.kiyo.eu"]');
    for (var i = 0; i < links.length; i++) {
      rewriteLink(links[i]);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { rewriteAllLinks(); });
  } else {
    rewriteAllLinks();
  }

  // Watch for lazily rendered content (e.g. header drawer hydration)
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        if (nodes[j].nodeType === 1) {
          // Check the added node itself and its children
          if (nodes[j].matches && nodes[j].matches('a[href*="konfigurator.kiyo.eu"]')) {
            rewriteLink(nodes[j]);
          }
          if (nodes[j].querySelectorAll) {
            rewriteAllLinks(nodes[j]);
          }
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Also run after Shopify section rendering (e.g. section reloads in editor)
  document.addEventListener('shopify:section:load', function () { rewriteAllLinks(); });
})();
